import './call-to-action.component.pug'
import './call-to-action.component.scss'

document.querySelectorAll('.call-to-action').forEach((root) => {
  if (!document.documentElement.classList.contains('touchevents')) {
    import(
      /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
    ).then(({ ScrollMagic }) => {
      const controller = new ScrollMagic.Controller()

      const background = root.querySelector('.call-to-action__background')
      const video = background.querySelector('video')
      const scene = new ScrollMagic.Scene({
        duration: '100%',
        offset: -window.innerHeight / 2,
        triggerElement: root
      })
      scene.addTo(controller)
      scene.on('enter', async function () {
        if (process.env.NODE_ENV === 'production') {
          if (video) {
            video.classList.add('played')
            await video.play()
          }
        }
      })
      scene.on('leave', async function () {
        if (video) {
          video.classList.remove('played')
          await video.pause()
        }
      })
      // scene.on('progress', function (event) {
      //   TweenLite.to(
      //     background,
      //     {
      //       translateY: `-${event.progress * 25}%`
      //     },
      //     1
      //   )
      // })
    })
  }
})
